/* eslint-disable no-warning-comments */

import { BackButton, ForwardButton } from 'components/button/button.styled'
import { ModeSelection } from 'components/modeSelection'
import { LocationForm, LocationsTableWizard } from 'features/admin/Location'
import { useLocationsWizard } from 'hooks/admin/useLocations'
import { useSecondStep } from 'hooks/admin/useWizard'
import React, { useRef } from 'react'
import { LocationType } from 'types/Location'

import { ButtonContainer, FormContent } from '../eventWizard.style'

interface SecondStepProps {
    onNext: (data: Record<string, any>) => void
    onPrevious: () => void
    eventData: Record<string, any>
    generatedEventId?: string
    initialEventLocationId?: string
    initialLocationId?: string
    partnerId?: string
    isEditMode?: boolean
}

// TODO: nincs vásárlás state elementve a db-bd

export const SecondStep: React.FC<SecondStepProps> = ({
    onNext,
    onPrevious,
    eventData,
    generatedEventId,
    initialEventLocationId,
    initialLocationId,
    partnerId,
    isEditMode,
}) => {
    const formRef = useRef<HTMLFormElement>(null)

    const {
        mode,
        selectedRow,
        setSelectedRow,
        onModeChange,
        handleNext: originalHandleNext,
        handleShowCreationSuccess,
    } = useSecondStep({
        initialEventLocationId,
        initialLocationId,
        onNext,
        onPrevious,
        eventData,
    })

    const eventId = eventData.event_id ?? generatedEventId

    useLocationsWizard({
        selectedRow,
        eventId,
        partnerId,
    })

    const handleLocationFormSuccess = (event_location_id?: string) => {
        if (event_location_id) {
            setSelectedRow({ event_location_id } as LocationType)
            handleShowCreationSuccess(event_location_id)
            onNext({ event_location_id })
        } else {
            handleShowCreationSuccess()
            originalHandleNext()
        }
    }

    const handleNext = async () => {
        if (mode === 'select' && selectedRow) {
            // If a location is selected and being edited in the form, submit the form
            if (selectedRow.location_id && formRef.current) {
                // Trigger form submit which will call handleSubmitEventLocation
                formRef.current.requestSubmit()
                // originalHandleNext will be called after successful form submission via handleLocationFormSuccess
                return
            } else if (selectedRow.event_location_id) {
                // Already an event location, just proceed
                originalHandleNext()
                return
            }
        }
        originalHandleNext()
    }

    return (
        <>
            <ButtonContainer hasbackbutton={true}>
                <BackButton icon="pi pi-arrow-left" label="Előző" onClick={onPrevious} />
                <ForwardButton icon="pi pi-arrow-right" iconPos="right" label="Következő" onClick={handleNext} />
            </ButtonContainer>
            {isEditMode ? (
                <FormContent>
                    <div
                        style={{
                            padding: '2rem',
                            textAlign: 'center',
                            backgroundColor: '#f9fafb',
                            borderRadius: '8px',
                            border: '1px solid #e5e7eb',
                        }}
                    >
                        <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '1rem' }}>
                            <i className="pi pi-lock" style={{ marginRight: '0.5rem' }}></i>A helyszín és nézőtér szerkesztése letiltva
                            esemény módosítása esetén
                        </p>
                        <p style={{ fontSize: '0.95rem', color: '#888' }}>
                            Helyszín: <strong>{eventData.location?.name || 'N/A'}</strong>
                        </p>
                        {eventData.location?.address && (
                            <p style={{ fontSize: '0.9rem', color: '#999', marginTop: '0.5rem' }}>Cím: {eventData.location.address}</p>
                        )}
                    </div>
                </FormContent>
            ) : (
                <>
                    <ModeSelection
                        options={[
                            { value: 'select', label: 'Létező helyszín kiválasztása az esemény számára' },
                            { value: 'create', label: 'Új helyszín felvétele az esemény számára' },
                        ]}
                        selectedValue={mode}
                        onChange={onModeChange}
                        buttonClassName="my-button"
                        selectedButtonClassName="selected"
                    />
                    <FormContent>
                        {mode === 'select' && (
                            <LocationsTableWizard
                                onSuccess={handleLocationFormSuccess}
                                selectedRow={selectedRow}
                                setSelectedRow={setSelectedRow}
                                eventId={eventId}
                                partnerId={partnerId}
                                formRef={formRef}
                            />
                        )}
                        {mode === 'create' && <LocationForm onSuccess={handleShowCreationSuccess} />}
                    </FormContent>
                </>
            )}
        </>
    )
}
